<mat-hint color="warn" class="main-hint block" *ngIf="!policy?.id">
    There is no {{formValue?.displayName}}, when you click remediate you are going to create new compliance policy with
    the desired
    values of the baseline
</mat-hint>

<mat-error *ngIf="formErrors">
    Please fix the baseline errors
</mat-error>

<form [formGroup]="form" *ngIf="loaded">

    <mat-accordion>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full  flex justify-between">

                    <mat-panel-title class="font-bold">
                        Basics
                    </mat-panel-title>

                    <div class="">
                        <sway-baseline-status
                            [hasError]="!policy?.id || errorString.includes('/policy/description')"></sway-baseline-status>
                    </div>

                </div>

            </mat-expansion-panel-header>

            <div>
                <table>
                    <thead>
                        <tr>
                            <th>
                                Field
                            </th>

                            <th>
                                Current Value
                            </th>

                            <th>
                                Desired Value
                            </th>

                            <th>
                                Status
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td class="field">

                                Display Name
                            </td>

                            <td colspan="3">
                                {{formValue?.displayName}}
                            </td>
                        </tr>


                        <tr>
                            <td class="field">

                                Description
                            </td>

                            <td>
                                {{policy?.description}}
                            </td>

                            <td>
                                <mat-form-field appearance="outline">
                                    <textarea formControlName="description" matInput></textarea>
                                </mat-form-field>
                            </td>

                            <td class="status">
                                <sway-baseline-status
                                    [hasError]="!policy?.id || errorString.includes('/policy/description')"></sway-baseline-status>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <div class="mb-6"></div>

    <mat-accordion>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full  flex justify-between">

                    <mat-panel-title class="font-bold">
                        System Security (Password)


                    </mat-panel-title>

                    <div class="">
                        <sway-baseline-status [hasError]="
                        !policy?.id ||

                            (errorString.includes('/policy/passwordRequired')
                            || errorString.includes('/policy/passwordRequiredType')
                            || errorString.includes('/policy/passswordMinimumLength')
                            || errorString.includes('/policy/passwordMinutesOfInactivityBeforeLock')
                            || errorString.includes('/policy/passwordExpirationDays')
                            || errorString.includes('/policy/passwordPreviousPasswordCountToBlock')
                            || errorString.includes('/policy/storageRequireEncryption')
                            || errorString.includes('/policy/securityRequireIntuneAppIntegrity')
                            )

                        "></sway-baseline-status>
                    </div>

                </div>

            </mat-expansion-panel-header>

            <div>
                <table>
                    <thead>
                        <tr>
                            <th>
                                Field
                            </th>

                            <th>
                                Current Value
                            </th>

                            <th>
                                Desired Value
                            </th>

                            <th>
                                Status
                            </th>
                        </tr>
                    </thead>

                    <tbody>


                        <tr>
                            <td class="field">
                                <div class="td-title">
                                    Require a password to unlock devices. <mat-icon
                                        [matTooltip]="tooltips.passwordRequired">info</mat-icon>
                                </div>
                            </td>

                            <td>
                                {{policy?.passwordRequired ? 'Required' : 'Not Configured'}}
                            </td>

                            <td>
                                Not Configured

                                <mat-slide-toggle (change)="markFormAsDirty()" color="primary" formControlName="passwordRequired">
                                    Required
                                </mat-slide-toggle>

                            </td>

                            <td class="status">
                                <sway-baseline-status
                                [hasError]="!policy?.id || errorString.includes('/policy/passwordRequired!')"></sway-baseline-status>

                            </td>

                        </tr>

                    <ng-container *ngIf="formValue?.passwordRequired">

                        <tr>
                            <td class="field">
                                <div class="td-title">

                                    Required password type
                                    <mat-icon
                                        [matTooltip]="tooltips.passwordRequiredType">info</mat-icon>
                                </div>
                            </td>

                            <td>
                                {{policy?.passwordRequiredType || '-'}}
                            </td>

                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select
                                        formControlName="passwordRequiredType">
                                        <mat-option value="deviceDefault">Device default</mat-option>
                                        <mat-option value="alphanumeric">Alphanumeric</mat-option>
                                        <mat-option value="alphabetic">Alphabetic</mat-option>
                                        <mat-option value="alphanumericWithSymbols">Alphanumeric with symbols</mat-option>
                                        <mat-option value="lowSecurityBiometric">Weak biometric</mat-option>
                                        <mat-option value="numeric">Numeric</mat-option>
                                        <mat-option value="numericComplex">Numeric complex</mat-option>
                                        <mat-option value="any">Any</mat-option>
                                    </mat-select>

                                </mat-form-field>
                            </td>

                            <td class="status">
                                <sway-baseline-status [ignore]="!passwordRequired"
                                        [hasError]="!policy?.id || errorString.includes('/policy/passwordRequiredType')"></sway-baseline-status>

                            </td>

                        </tr>

                        <tr>

                            <td class="field">
                                <div class="td-title">

                                    Minimum password length

                                    <mat-icon
                                        [matTooltip]="tooltips.passwordMinimumLength">info</mat-icon>

                                </div>
                            </td>

                            <td>
                                {{ policy?.passwordMinimumLength ?? 'Not configured' }}
                            </td>

                            <td>
                                <mat-form-field appearance="outline">

                                    <input [readonly]="!passwordRequired" type="number" matInput
                                        formControlName="passwordMinimumLength" />

                                    <mat-error
                                        *ngIf="form.get('passwordMinimumLength').hasError('max') || form.get('passwordMinimumLength').hasError('min')">
                                        The value must be between 4 and 16.
                                    </mat-error>


                                    <mat-error
                                        *ngIf="form.get('passwordMinimumLength').hasError('required')">
                                        The value must be between 4 and 16.
                                    </mat-error>
                                </mat-form-field>

                            <td class="status">
                                <sway-baseline-status [ignore]="!passwordRequired"
                                    [hasError]="!policy?.id || errorString.includes('/policy/passwordMinimumLength')"></sway-baseline-status>

                            </td>

                        </tr>

                        <tr>
                            <td class="field">
                                <div class="td-title">
                                    Maximum minutes of inactivity until screen locks
                                    <mat-icon
                                        [matTooltip]="tooltips.passwordMinutesOfInactivityBeforeLock">info</mat-icon>
                                </div>
                            </td>

                            <td>
                                {{convertMinuteToString(policy?.passwordMinutesOfInactivityBeforeLock) || '-'}}
                            </td>

                            <td>

                                <mat-form-field appearance="outline">

                                    <mat-select [disabled]="!passwordRequired"
                                        formControlName="passwordMinutesOfInactivityBeforeLock">
                                        <mat-option [value]="0">Not configured</mat-option>
                                        <mat-option [value]="1">1 minute</mat-option>
                                        <mat-option [value]="5">5 minutes</mat-option>
                                        <mat-option [value]="15">15 minutes</mat-option>
                                        <mat-option [value]="30">30 minutes</mat-option>
                                        <mat-option [value]="60">1 hour</mat-option>
                                        <mat-option [value]="240">4 hours</mat-option>
                                        <mat-option [value]="480">8 hours</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>

                            <td class="status">
                                <sway-baseline-status [ignore]="!passwordRequired"
                                [hasError]="!policy?.id || errorString.includes('/policy/passwordMinutesOfInactivityBeforeLock')"></sway-baseline-status>

                            </td>

                        </tr>

                        <tr>
                            <td class="field">
                                <div class="td-title">

                                    Password expiration (days) <mat-icon
                                        [matTooltip]="tooltips.passwordExpirationDays">info</mat-icon>
                                </div>
                            </td>

                            <td>
                                {{policy?.passwordExpirationDays || '-'}}
                            </td>

                            <td>
                                <mat-form-field appearance="outline" class="full-width">
                                    <input [readonly]="!passwordRequired" type="number" matInput
                                        formControlName="passwordExpirationDays" />

                                    <mat-error
                                        *ngIf="form.get('passwordExpirationDays').hasError('max') || form.get('passwordExpirationDays').hasError('min')">
                                        The value must be between 1 and 365.
                                    </mat-error>

                                    <mat-error
                                    *ngIf="form.get('passwordExpirationDays').hasError('required')">
                                    The value must be between 1 and 365.
                                </mat-error>
                                </mat-form-field>
                            </td>

                            <td class="status">
                                <sway-baseline-status [ignore]="!passwordRequired"
                                [hasError]="!policy?.id || errorString.includes('/policy/passwordExpirationDays')"></sway-baseline-status>

                            </td>

                        </tr>

                        <tr>
                            <td class="field">
                                <div class="td-title">

                                    Number of previous passwords to prevent reuse
                                    <mat-icon [matTooltip]="tooltips.passwordPreviousPasswordCountToBlock">info</mat-icon>
                                </div>
                            </td>

                            <td>
                                {{policy?.passwordPreviousPasswordCountToBlock || '-'}}
                            </td>

                            <td>
                                <mat-form-field appearance="outline" class="full-width">
                                    <input type="number" matInput
                                        formControlName="passwordPreviousPasswordCountToBlock" />

                                    <mat-error
                                        *ngIf="form.get('passwordPreviousPasswordCountToBlock').hasError('max') || form.get('passwordPreviousPasswordCountToBlock').hasError('min')">

                                        The value must be between 1 and 24.
                                    </mat-error>


                                    <mat-error
                                        *ngIf="form.get('passwordPreviousPasswordCountToBlock').hasError('required')">

                                        The value must be between 1 and 24.
                                    </mat-error>
                                </mat-form-field>
                            </td>

                            <td class="status">
                                <sway-baseline-status [ignore]="!passwordRequired"
                                    [hasError]="!policy?.id || errorString.includes('/policy/passwordPreviousPasswordCountToBlock')"></sway-baseline-status>
                            </td>

                        </tr>

                    </ng-container>

                        <tr>
                            <td class="field">
                                <div class="td-title">
                                    Require encryption of data storage on device <mat-icon
                                        [matTooltip]="tooltips.storageRequireEncryption">info</mat-icon>
                                </div>
                            </td>

                            <td>
                                {{policy?.storageRequireEncryption ? 'Required' : 'Not Configured'}}
                            </td>

                            <td>
                                Not Configured

                                <mat-slide-toggle (change)="markFormAsDirty()" color="primary" formControlName="storageRequireEncryption">
                                    Required
                                </mat-slide-toggle>

                            </td>

                            <td class="status">
                                <sway-baseline-status
                                    [hasError]="!policy?.id || errorString.includes('/policy/storageRequireEncryption!')"></sway-baseline-status>

                            </td>

                        </tr>

                        <tr>
                            <td class="field">
                                <div class="td-title">
                                    Intune app runtime integrity <mat-icon
                                        [matTooltip]="tooltips.securityRequireIntuneAppIntegrity">info</mat-icon>
                                </div>
                            </td>

                            <td>
                                {{policy?.securityRequireIntuneAppIntegrity ? 'Required' : 'Not Configured'}}
                            </td>

                            <td>
                                Not Configured

                                <mat-slide-toggle (change)="markFormAsDirty()" color="primary" formControlName="securityRequireIntuneAppIntegrity">
                                    Required
                                </mat-slide-toggle>

                            </td>

                            <td class="status">
                                <sway-baseline-status
                                    [hasError]="!policy?.id || errorString.includes('/policy/securityRequireIntuneAppIntegrity!')"></sway-baseline-status>

                            </td>

                        </tr>

                    </tbody>
                </table>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <div class="mb-6"></div>

    <mat-accordion>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full  flex justify-between">

                    <mat-panel-title class="font-bold">
                        Device Properties
                    </mat-panel-title>

                    <div class="">
                        <sway-baseline-status
                            [hasError]="!policy?.id || errorString.includes('/policy/description')"></sway-baseline-status>
                    </div>

                </div>

            </mat-expansion-panel-header>

            <div>
                <table>
                    <thead>
                        <tr>
                            <th>
                                Field
                            </th>

                            <th>
                                Current Value
                            </th>

                            <th>
                                Desired Value
                            </th>

                            <th>
                                Status
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td class="field">
                                <div class="td-title">

                                    Minimum OS version <mat-icon
                                        [matTooltip]="tooltips.osMinimumVersion">info</mat-icon>
                                </div>

                            </td>

                            <td>
                                {{policy?.osMinimumVersion || '-'}}
                            </td>

                            <td>
                                <mat-form-field appearance="outline" class="full-width">

                                    <input matInput formControlName="osMinimumVersion" />

                                    <mat-error *ngIf="form.get('osMinimumVersion').hasError('max')">Must be smaller than
                                        the maximum
                                        OS version</mat-error>
                                    <mat-error *ngIf="form.get('osMinimumVersion').hasError('pattern')">Must be a valid
                                        version
                                        format. Example: 9, 10</mat-error>
                                </mat-form-field>
                            </td>

                            <td class="status">
                                <sway-baseline-status
                                    [hasError]="!policy?.id || errorString.includes('/policy/osMinimumVersion')"></sway-baseline-status>

                            </td>
                        </tr>

                        <tr>
                            <td class="field">
                                <div class="td-title">
                                    Maximum OS version<mat-icon [matTooltip]="tooltips.osMaximumVersion">info</mat-icon>
                                </div>
                            </td>

                            <td>
                                {{policy?.osMaximumVersion || '-'}}
                            </td>

                            <td>
                                <mat-form-field appearance="outline" class="full-width">

                                    <input matInput formControlName="osMaximumVersion" />
                                    <mat-error *ngIf="form.get('osMaximumVersion').hasError('pattern')">Must be a valid
                                        version
                                        format. Example: 4.3.06, 7.01.4, etc.</mat-error>
                                    <mat-error *ngIf="form.get('osMaximumVersion').hasError('min')">Must be greater than
                                        the minimum
                                        OS version</mat-error>

                                </mat-form-field>
                            </td>

                            <td class="status">
                                <sway-baseline-status
                                    [hasError]="!policy?.id || errorString.includes('/policy/osMaximumVersion')"></sway-baseline-status>

                            </td>
                        </tr>

                        <tr>
                            <td class="field">
                                <div class="td-title">
                                    Minimum security patch level<mat-icon [matTooltip]="tooltips.minAndroidSecurityPatchLevel">info</mat-icon>
                                </div>
                            </td>

                            <td>
                                {{policy?.minAndroidSecurityPatchLevel || '-'}}
                            </td>

                            <td>
                                <mat-form-field appearance="outline" class="full-width">
                                    <input
                                      matInput
                                      [matDatepicker]="picker"
                                      formControlName="minAndroidSecurityPatchLevel"
                                      (dateChange)="onMinPatchDateChange($event.value)"
                                      placeholder="YYYY-MM-DD"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>

                                  </mat-form-field>
                            </td>

                            <td class="status">
                                <sway-baseline-status
                                    [hasError]="!policy?.id || errorString.includes('/policy/minAndroidSecurityPatchLevel')"></sway-baseline-status>

                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <div class="mb-6"></div>

    <mat-accordion>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full  flex justify-between">

                    <mat-panel-title class="font-bold">
                        Device Health
                    </mat-panel-title>

                    <div class="">
                        <sway-baseline-status [hasError]="
                        !policy?.id ||
                        errorString.includes('/policy/deviceThreatProtectionRequiredSecurityLevel') ||
                        errorString.includes('/policy/securityRequireSafetyNetAttestationBasicIntegrity') ||
                        errorString.includes('/policy/securityRequireSafetyNetAttestationCertifiedDevice')

                        "></sway-baseline-status>
                    </div>

                </div>

            </mat-expansion-panel-header>

            <div>
                <table>
                    <thead>
                        <tr>
                            <th>
                                Field
                            </th>

                            <th>
                                Current Value
                            </th>

                            <th>
                                Desired Value
                            </th>

                            <th>
                                Status
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td class="field">
                                Require the device to be at or under the Device Threat Level<mat-icon
                                [matTooltip]="tooltips.deviceThreatProtectionRequiredSecurityLevel">info</mat-icon>
                            </td>

                            <td>
                                {{policy?.deviceThreatProtectionRequiredSecurityLevel}}
                            </td>

                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select
                                        formControlName="deviceThreatProtectionRequiredSecurityLevel">
                                        <mat-option value="notSet">Not Configured</mat-option>
                                        <mat-option value="high">High</mat-option>
                                        <mat-option value="medium">Medium</mat-option>
                                        <mat-option value="low">Low</mat-option>
                                        <mat-option value="secured">Secured</mat-option>

                                    </mat-select>
                                </mat-form-field>
                            </td>

                            <td class="status">
                                <sway-baseline-status [hasError]="!policy?.id || errorString.includes('/policy/deviceThreatProtectionRequiredSecurityLevel')"></sway-baseline-status>
                            </td>
                        </tr>


                        <tr>
                            <td class="field">
                                Play Integrity Verdict<mat-icon
                                [matTooltip]="tooltips.playIntegrityVerdict">info</mat-icon>
                            </td>

                            <td>
                                <div *ngIf="!policy?.securityRequireSafetyNetAttestationBasicIntegrity && !policy?.securityRequireSafetyNetAttestationCertifiedDevice">Not Configured</div>
                                <div *ngIf="policy?.securityRequireSafetyNetAttestationBasicIntegrity && !policy?.securityRequireSafetyNetAttestationCertifiedDevice">Check Basic Integrity</div>
                                <div *ngIf="policy?.securityRequireSafetyNetAttestationBasicIntegrity && policy?.securityRequireSafetyNetAttestationCertifiedDevice">Check Basic and Device Integrity</div>
                            </td>

                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="combinationOfCertifiedDeviceAndBasicIntegrity">
                                        <mat-option value="notSet">Not Configured</mat-option>
                                        <mat-option value="optionOne">Check Basic Integrity</mat-option>
                                        <mat-option value="optionTwo">Check Basic and Device Integrity</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>

                            <td class="status">
                                <sway-baseline-status [hasError]="!policy?.id || errorString.includes('/policy/securityRequireSafetyNetAttestationBasicIntegrity') || errorString.includes('/policy/securityRequireSafetyNetAttestationCertifiedDevice')"></sway-baseline-status>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <div class="mb-6"></div>

    <mat-accordion>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full  flex justify-between">

                    <mat-panel-title class="font-bold">
                        Microsoft Defender for Endpoint


                    </mat-panel-title>

                    <div class="">
                        <sway-baseline-status
                            [hasError]="!policy?.id || errorString.includes('/policy/advancedThreatProtectionRequiredSecurityLevel')"
                        ></sway-baseline-status>
                    </div>

                </div>

            </mat-expansion-panel-header>

            <div>
                <table>
                    <thead>
                        <tr>
                            <th>
                                Field
                            </th>

                            <th>
                                Current Value
                            </th>

                            <th>
                                Desired Value
                            </th>

                            <th>
                                Status
                            </th>
                        </tr>
                    </thead>

                    <tbody>


                        <tr>
                            <td class="field">
                                <div class="td-title">

                                    Require the device to be at or under the machine risk score:
                                    <mat-icon
                                        [matTooltip]="tooltips.advancedThreatProtectionRequiredSecurityLevel">info</mat-icon>
                                </div>
                            </td>

                            <td>
                                {{policy?.advancedThreatProtectionRequiredSecurityLevel || 'Not Configured'}}
                            </td>

                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="advancedThreatProtectionRequiredSecurityLevel">
                                        <mat-option value="notSet">Not Configured</mat-option>
                                        <mat-option value="unavailable">Clear</mat-option>
                                        <mat-option value="low">Low</mat-option>
                                        <mat-option value="medium">Medium</mat-option>
                                        <mat-option value="high">High</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>

                            <td class="status">
                                <sway-baseline-status
                                    [hasError]="!policy?.id || errorString.includes('/policy/advancedThreatProtectionRequiredSecurityLevel')"></sway-baseline-status>

                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

    <div class="mb-6"></div>

    <app-intune-policy-assignments [policy]="policy" [errorsString]="errorsString" [assignments]="assignments"
        [form]="form" [tenant_id]="tenant_id"> </app-intune-policy-assignments>


</form>
